var Qs = require('qs')
const baseURL = 'http://192.168.1.214:15000/financial-data/api'   //道口测试接口
// const baseURL = 'http://192.168.2.237:15000/financial-data/api'   //孟锰


const config = {
    // `baseURL` 将自动加在 `url` 前面，除非 `url` 是一个绝对 URL。
    // 它可以通过设置一个 `baseURL` 便于为 axios 实例的方法传递相对 URL
    baseURL,
    headers: {
      // 'Content-Type':'application/x-www-form-urlencoded'
      'Content-Type': 'application/json'
    },
    params: {},
    // `paramsSerializer` 是一个负责 `params` 序列化的函数
    paramsSerializer: function (params) {
      return Qs.stringify(params)
    },
    data: {},
    timeout: 60000,
    withCredentials: false, // default
    responseType: 'json', // default
    maxContentLength: 2000,
    // 定义可获得的http响应状态码
    validateStatus: function (status) {
      return status >= 200 && status < 300 // default
    },
    // `transformRequest` 允许在向服务器发送前，修改请求数据
    transformRequest: function (data) {
      //由于使用的form-data传数据所以要格式化
      return data
    },
    maxRedirects: 5 // default
  }
  export default config